import { CountryCode } from '@dayetopia/types';
import {
  MEDICATION_CHLAMYDIA_IMG,
  MEDICATION_MGENITALIUM_IMG,
  MEDICATION_TRICHOMONIASIS_IMG,
  MEDICATION_THRUSH_IMG,
  MEDICATION_BV_IMG
} from '@constants';
import { Medication, MedicationType, ProductCode } from '@contracts';
import { isCountryMatch } from '@utils/helpers';
import { TreatmentData, getTreatments } from './TreatmentsData';

export interface MedicationData {
  name: Medication;
  title: string;
  image: string;
  type: MedicationType;
  smallImage: string;
  cartImage?: string;
  country?: string;
  priceFrom?: string;
  priceFromUS?: string;
  product?: ProductCode;
  isAntibiotic?: boolean;
  treatments?: TreatmentData[];
}

export interface MedicationOptions {
  names?: string[];
  country?: CountryCode;
}

export function getMedications(options?: MedicationOptions): MedicationData[] {
  return medicationsData
    .filter((medication) => {
      let nameMatch = true;
      let countryMatch = true;

      if (options?.names && options?.names.length) {
        nameMatch = options?.names.includes(medication.name);
      }

      if (options?.country && medication.country) {
        countryMatch = !!medication.country && isCountryMatch(medication.country, options?.country);
      }

      return nameMatch && countryMatch;
    })
    .map((medicationData) => {
      const treatments = getTreatments({ country: options?.country, medications: [medicationData?.name] });
      let lowestTreatmentPrice = Infinity;
      let lowestTreatmentPriceUS = Infinity;

      treatments.forEach((treatment) => {
        if (treatment?.price) {
          const treatmentPrice = Number(treatment.price);

          if (treatmentPrice < lowestTreatmentPrice) {
            lowestTreatmentPrice = treatmentPrice;
          }
        }

        if (treatment?.priceUS) {
          const treatmentPriceUS = Number(treatment.priceUS);

          if (treatmentPriceUS < lowestTreatmentPriceUS) {
            lowestTreatmentPriceUS = treatmentPriceUS;
          }
        }
      });

      return {
        ...medicationData,
        priceFrom: lowestTreatmentPrice === Infinity ? 'N/A' : lowestTreatmentPrice.toFixed(2).toString(),
        priceFromUS: lowestTreatmentPriceUS === Infinity ? 'N/A' : lowestTreatmentPriceUS.toFixed(2).toString(),
        treatments
      };
    });
}
// TODO: Do we need this file or only TreatmentsData and TreatmentTypes as the Medications are basically the TreatmentTypes
export const medicationsData: MedicationData[] = [
  {
    name: Medication.CHLAMYDIA,
    title: 'Antibiotic treatment for Chlamydia',
    isAntibiotic: true,
    type: MedicationType.STI,
    image: MEDICATION_CHLAMYDIA_IMG,
    smallImage: MEDICATION_CHLAMYDIA_IMG
  },
  {
    name: Medication.TRICHOMONIASIS,
    title: 'Antibiotic treatment for Trichomoniasis',
    isAntibiotic: true,
    type: MedicationType.STI,
    image: MEDICATION_TRICHOMONIASIS_IMG,
    smallImage: MEDICATION_TRICHOMONIASIS_IMG
  },
  {
    name: Medication.MYCOPLASMA_GENITALIUM,
    title: 'Antibiotic treatment for infection, caused by Mycoplasma genitalium',
    isAntibiotic: true,
    type: MedicationType.STI,
    image: MEDICATION_MGENITALIUM_IMG,
    smallImage: MEDICATION_MGENITALIUM_IMG
  },
  {
    name: Medication.BV,
    title: '',
    isAntibiotic: true,
    type: MedicationType.BV,
    image: MEDICATION_BV_IMG,
    smallImage: MEDICATION_BV_IMG
  },
  {
    name: Medication.THRUSH,
    title: '',
    isAntibiotic: true,
    type: MedicationType.Yeast,
    image: MEDICATION_THRUSH_IMG,
    smallImage: MEDICATION_THRUSH_IMG
  }
];
